import { useIonModal } from '@ionic/react'
import { useDispatch } from 'react-redux'
import { COMPLETE_INPUT } from '../redux/actions'
import BarCodeScanner from './BarCodeScanner'
import Button from './Button'

interface Props {
  label: string
  inputToFill: string
  storeForm: string
}

const ScanBarCode = ({ label, inputToFill, storeForm }: Props) => {
  const dispatch = useDispatch()
  const [present, dismiss] = useIonModal(BarCodeScanner, {
    onDismiss: (data: string, role: string) => dismiss(data, role)
  })

  const scanBarCode = () => {
    present({
      onDidDismiss: (event: any) => {
        if (event.detail.role !== 'confirm') return
        dispatch({
          type: COMPLETE_INPUT,
          payload: { name: inputToFill, value: event.detail.data, storeForm }
        })
      }
    })
  }

  return (
    <div className="scanner-button">
      <Button id="open-scanner-modal" className="submit-outline-button" handleSubmit={scanBarCode} label={label} />
    </div>
  )
}

export default ScanBarCode
